import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListSubheader from '@material-ui/core/ListSubheader';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import Checkbox from '@material-ui/core/Checkbox';

class EnhancedGridHead extends Component {
    render() {
        const { numSelected, onSelectAllClick, rowCount } = this.props;
        return (
            <ListSubheader component="div">
                <div style={{ display: 'inline-block', width: '20%' }}>
                    <Typography color='inherit' variant='subtitle1'>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                        {numSelected > 0 ? `${numSelected} selected` : this.props.gridTitle}
                    </Typography>
                </div>
                <div style={{ display: 'inline-block', textAlign: 'right', width: '80%' }}>
                    {numSelected > 0 ?
                        this.props.actions.map((action) => {
                            return (
                                <div key={action.action} className={this.props.classes.action}>
                                    <Button variant="outlined" onClick={() => this.props.handleAction(action.onAction)}>
                                        {action.icon ?
                                            <Icon
                                                name={action.icon}
                                                size={'20px'}
                                            />
                                            : ''}
                                        {` ${action.action}`}
                                    </Button>
                                </div>
                            );
                        })
                        :
                        this.props.columnData && this.props.columnData > 0 ?
                            <div>
                                {'Sort by: '}
                                <Select value={this.props.sortBy} onChange={this.props.handleSortChange}>
                                    {this.props.columnData.map((column) => {
                                        return (
                                            <MenuItem key={column.id} value={column.id} >{column.name}</MenuItem>
                                        );
                                    })}
                                </Select>
                                <IconButton name='fa-arrows-v' onClick={this.props.handleReverseChange} primaryColor='#000' secondaryColor='#9b9b9b' />
                            </div>
                            : ''
                    }
                </div>
            </ListSubheader>
        );
    }
}
EnhancedGridHead.propTypes = {
    gridTitle: PropTypes.string.isRequired,
    columnData: PropTypes.array.isRequired,
    actions: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    sortBy: PropTypes.string.isRequired,
    handleSortChange: PropTypes.func.isRequired,
    handleReverseChange: PropTypes.func.isRequired,
    handleAction: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export default EnhancedGridHead;